import { FC, ReactNode, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { secondaryMarketTradeBlotterPreferenceStateLoaded } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.action';
import { fromSecondaryTradeBlotter } from 'state/selectors';

import { emptyBlotterPreferences } from '../../shared/Blotter/Grid/blotter.model';
import { BlotterPreferencesLoadingErrorModal } from '../blotterPreferencesLoadingErrorModal';

export const PreferencesLoadingErrorModal: FC<{ children: ReactNode }> = ({ children }) => {
  const dispatch = useDispatch();

  const hasLoadingError = useSelector(fromSecondaryTradeBlotter.areBlotterPreferencesInError);
  const onContinueAndDefault = useCallback(
    () => dispatch(secondaryMarketTradeBlotterPreferenceStateLoaded(emptyBlotterPreferences)),
    [dispatch],
  );

  return (
    <BlotterPreferencesLoadingErrorModal hasLoadingError={hasLoadingError} onContinueAndDefault={onContinueAndDefault}>
      {children}
    </BlotterPreferencesLoadingErrorModal>
  );
};
